import BrandLogo from './BrandLogo';

const SplashScreen = () => {
  return (
    <div className="bg-background text-on-background fixed top-0 left-0 h-full w-full z-[999]">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="text-primary">
          <BrandLogo
            compact
            iconSize="72px"
            imageClassName="h-20 w-20 object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
